import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { useAuthContext } from "@/components/AuthorizationProvider";
import { usePrivy } from "@privy-io/react-auth";

// Select the appropriate GA Measurement ID based on the environment
const gaMeasurementId = import.meta.env.PROD
  ? import.meta.env.VITE_GA_MEASUREMENT_ID_PRODUCTION
  : import.meta.env.VITE_GA_MEASUREMENT_ID_DEVELOPMENT;

ReactGA.initialize(gaMeasurementId); // Initialize with the correct Measurement ID

// Hook to track page views with username, role, and subpage details
export const usePageTracking = () => {
  const location = useLocation();
  const { ready, authenticated } = usePrivy();
  const { userAuthorization } = useAuthContext();

  useEffect(() => {
    // Track subpage and, if authenticated, add username and role
    const pageViewData = {
      hitType: "pageview",
      page: location.pathname,
      title: location.pathname, // Optional title
      user: null as string | null,
    };

    // Include email and role if the user is authenticated
    if (ready && authenticated && userAuthorization) {
      pageViewData.user = userAuthorization.qs_username;

      if (userAuthorization.role) {
        // Set the user's role as a custom dimension
        ReactGA.set({ role: userAuthorization.role });
      }
    }

    ReactGA.send(pageViewData);
  }, [location, ready, authenticated, userAuthorization]);
};
